module.exports = __webpack_public_path__ + "static/media/Logo SGB Escape Blanc.21e51e84.png";